import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';
import { withViewport } from '@prisjakt/ui-viewport';
import ModalComponent from 'src/components/modal';

export const ProductPage = styled.div.attrs({ 'data-test': 'ProductPage' })`
  position: relative;

  /* This is needed or the review action dropdown will be obscured */
  .pj-ui-panel--row {
    overflow: visible;
  }

  /* this is not great */
  .pj-ui-scroll-link {
    button:hover {
      color: ${p => p.theme.text.callToActionHover};
      text-decoration: underline;
    }
  }

  .pj-ui-price-row {
    width: 100%;
  }

  .product-header--content {
    flex-direction: row;
  }
`;

const backToTopButtonDropShadow = '0 1px 3px rgba(0, 0, 0, 0.3)';

type BackToTopButtonProps = {
  viewport: {
    top: number;
    scroll: {
      yDirection: number;
    };
  };
};

const BackToTopButtonComponent = styled.button.attrs(() => ({
  type: 'button',
}))<BackToTopButtonProps>`
  position: fixed;
  bottom: 10px;
  ${media.hideOutsiderAd`
    right: 10px;
  `};
  ${media.showOutsiderAd`
    left: 50%;
    margin-left: ${layout.siteWidth.value * 0.5 - 200}px;
  `};
  background: ${p => p.theme.colors.yellove500};
  border-radius: ${layout.borderRadius};
  box-shadow: ${backToTopButtonDropShadow};
  border: 1px solid ${p => p.theme.colors.yellove500};
  cursor: pointer;
  padding: 10px 12px;
  visibility: ${props =>
    props.viewport &&
    props.viewport.top > 500 &&
    props.viewport.scroll.yDirection > 0
      ? 'visible'
      : 'hidden'};
  opacity: ${props =>
    props.viewport &&
    props.viewport.top > 500 &&
    props.viewport.scroll.yDirection > 0
      ? 0.9
      : 0};
  transition: opacity 0.2s linear;
  z-index: 4;

  :hover {
    color: ${p => p.theme.text.callToActionHover};
    background-color: ${p => p.theme.colors.yellove500};
  }

  :focus {
    background-color: ${p => p.theme.colors.yellove500};
    box-shadow: ${backToTopButtonDropShadow}, 0 0 0 4px #000;
    opacity: 1;
  }

  :focus:not(:focus-visible) {
    box-shadow: ${backToTopButtonDropShadow};
  }
`;

export const BackToTopButton = withViewport(BackToTopButtonComponent);

export const TabContentWrapper = styled.div`
  padding: 0 ${layout.measurements.spacing100};
`;

export const Modal = styled(ModalComponent)`
  && {
    padding: ${layout.measurements.spacing150};

    ${media.smallOnly`
      width: 100vw;
      max-width: 100vw;
      bottom: 0;
      margin: 0;
    `};
  }
`;
